<!-- @format -->
<basic-information-application-confirm-tag>


    <div if={! state.exits_data}>
        <p class="text">現在、登録基本情報の更新申請はありません</p>
    </div>

    <div if={state.exits_data }>

        <p class="text" style="text-align:center;font-size:1.2rem;font-weight: bold;color:red;margin-top:2rem">
            以下の内容で現在登録基本情報の更新を申請中です。<br/>申請内容の確認を行っておりますので、今しばらくお待ちください。
        </p>

        <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">登録基本情報</h2>

        <table class="detail_table">
            <tr class="detail_table-row">
                <th class="information_table-heading">本名</th>
                <td class="information_table-data">
                    <div class="box_flex02 field">
                        <div class="box_w40 margin-spacing-2_right">
                            <label class="form-heading" for="family_name">姓</label>
                            <span class="text" id="family_name">{state.application.family_name}</span>

                        </div>
                        <div class="box_w40 field">
                            <label class="form-heading" for="last_name">名</label>
                            <span class="text" id="last_name">{state.application.last_name}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="information_table-heading">フリガナ</th>
                <td class="information_table-data">
                    <div class="box_flex02">
                        <div class="box_w40 field margin-spacing-2_right">
                            <label class="form-heading" for="family_kana">姓</label>
                            <span class="text" id="family_kana">{state.application.family_kana}</span>
                        </div>
                        <div class="box_w40 field">
                            <label class="form-heading" for="last_kana">名</label>
                            <span class="text" id="last_kana">{state.application.last_kana}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="information_table-heading">生年月日</th>
                <td class="information_table-data">
                    <div class="box_flex01">
                        <div class="box_w50 field">
                            <span class="text" id="birthday">{state.application.birthday}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="detail_table-heading">性別</th>
                <td class="detail_table-data">
                    <div class="box_flex01">
                    <span class="text">

                        <span if={state.application.sex === 1} class="text">男性</span>
                        <span if={state.application.sex === 2} class="text">女性</span>
                        <span if={state.application.sex === 3} class="text">その他</span>
                        <span if={state.application.sex === 4} class="text">無回答</span>

                    </span>
                    </div>
                </td>
            </tr>
            <tr class="detail_table-row">
                <th class="information_table-heading">住所</th>
                <td class="information_table-data">
                    <div class="inner_form">
                        <label class="form-heading" for="postal_code">郵便番号（ハイフンなし）</label>
                        <div class="box_w50 field item_margin">
                            <span id="postal_code" class="text">{state.application.zip}</span>
                        </div>


                        <label class="form-heading" for="address1">住所1（都道府県 市区町村 番地）</label>
                        <div class="box_w50 field item_margin">
                            <span class="text" id="address1">{state.application.address1}</span>
                        </div>


                        <label class="form-heading" for="address2">住所2（建物名、フロアなど）</label>
                        <div class="box_w50 item_margin">
                            <span class="text" id="address2">{state.application.address2}</span>
                        </div>
                    </div>
                </td>
            </tr>
        </table>

        <div>
            <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">本人確認書類</h2>

            <div style="margin-bottom: 1rem">
                <label class="form-heading">提出した書類</label>
                <p class="text">

                    <span if={state.application.identity_type === "driver-lisence"} class="text">運転免許証</span>
                    <span if={state.application.identity_type === "passport"} class="text">パスポート</span>
                    <span if={state.application.identity_type === "my-number-card"}
                          class="text">マイナンバーカード</span>
                    <span if={state.application.identity_type === "immigration"} class="text">特別永住者証明書</span>

                </p>
            </div>

            <div style="margin-bottom: 1rem">
                <label class="form-heading">提出するページ①</label>
                <!--<img src={file_url(1)} width="30%">-->
                <span>アップロード済み</span>
            </div>

            <div style="margin-bottom: 1rem">
                <label class="form-heading">提出するページ②</label>
                <!--<img src={file_url(2)} width="30%">-->
                <span>アップロード済み</span>
            </div>

        </div>

        <div>
            <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">マイナンバー</h2>

            <div style="margin-bottom: 1rem">
                <label class="form-heading">マイナンバー</label>
                <p class="text">
                    {state.application.mynumber}
                </p>
            </div>

            <div style="margin-bottom: 1rem">
                <label class="form-heading">マイナンバー確認画像：表</label>
                <!--<img src={file_url(3)} width="30%">-->
                <span>アップロード済み</span>
            </div>

            <div style="margin-bottom: 1rem">
                <label class="form-heading">マイナンバー確認画像：裏</label>
                <!--<img src={file_url(4)} width="30%">-->
                <span>アップロード済み</span>
            </div>

        </div>

        <div>
            <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">適格請求書発行事業者</h2>
        </div>
        <p class="text">
            <strong>
                <invoice-provider-state-jname
                        invoice_provider_state={state.application.invoice_provider_state}/>
            </strong>
            <span if={state.application.invoice_provider_state===20}>
            (発行事業者番号：{state.application.invoice_provider_number_prefix}{state.application.invoice_provider_number_body})
        </span>
        </p>

    </div>


    <style>
        .item_margin {
            margin-bottom: 1rem
        }
    </style>

    <script>
        import di from "dependency-injection";
        import basicInformation from "@model/basicInformation/api";
        import invoiceProviderForm from "@tags/parts/info/basic-information/invoice-provider-form.riot";
        import invoiceProviderStateJname from "@tags/parts/info/invoice-provider-state-jname.riot";

        export default {
            components: {
                'invoice-provider-form-tag': invoiceProviderForm,
                "invoice-provider-state-jname": invoiceProviderStateJname
            },
            basicInformation: basicInformation,
            Sexes: {
                1: '男性',
                2: '女性',
                3: 'その他',
                4: '無回答'
            },
            state: {
                invoice_provider_number_error_message: '',
                application: {
                    address1: null,
                    address2: null,
                    application_type: null,
                    birthday: null,
                    created_at: null,
                    family_kana: null,
                    family_name: null,
                    identity_type: null,
                    invoice_provider_number_body: null,
                    invoice_provider_number_prefix: null,
                    invoice_provider_state: null,
                    last_kana: null,
                    last_name: null,
                    mynumber: null,
                    sex: null,
                    zip: null,
                },
                exits_data: false,
            },
            onMounted() {
                const my = this;
                this.api = di.createApi('info');
                this.api.request('basic-information-application-confirm', 'fetch')
                    .then(data =>
                        my.update({
                            application: data,
                            exits_data: (Object.keys(data).length >= 1)
                        })
                    );
            },
            file_url(file_no) {
                return "/info/basicInformationApplicationConfirm/api/v1/tmpfile?key=file" + file_no
            }
        }
    </script>
</basic-information-application-confirm-tag>